import {SMALL_MODAL, FULL_MODAL, REPORT_NAME} from './types'
import {report} from '../../../api/api-endpoints'
import {HMAO} from '../../../config/region.js'
import region from '../../../utils/region.js'

import {cardClassFull, cardClassOnlyApo, cardClassWithOutApo, cardClassEmpty} from "./types";

const configDataDefault = {
  1: {
    id: REPORT_NAME.TP2, // 5
    title: 'Отчет по форме 2ТП(отходы)',
    windowType: FULL_MODAL,
    col: 1,
    showApo: true,
    endpoint: report.tpdeparture,
    cardClass: cardClassFull
  },
  2: {
    id: REPORT_NAME.INDICATOR, // 9
    title: 'Целевые показатели',
    windowType: SMALL_MODAL,
    col: 2,
    endpoint: report.indicator,
    cardClass: cardClassEmpty
  },
  3: {
    id: REPORT_NAME.RSO, // 13
    title: 'Сбор РСО',
    windowType: SMALL_MODAL,
    col: 3,
    endpoint: report.rso,
    cardClass: cardClassEmpty
  },
  4: {
    id: REPORT_NAME.BATTERY, // 14
    title: 'Сбор элементов питания',
    windowType: SMALL_MODAL,
    col: 4,
    endpoint: report.battery,
    cardClass: cardClassEmpty
  },
  5: {
    id: REPORT_NAME.UNAUTH, // 6
    title: 'Реестр. Несанкционированные свалки',
    windowType: FULL_MODAL,
    col: 1,
    showApo: true,
    endpoint: report.dump,
    cardClass: cardClassFull
  },
  6: {
    id: REPORT_NAME.MSN, // 12
    title: 'Реестр. Места сбора и накопления',
    windowType: FULL_MODAL,
    col: 2,
    showApo: true,
    endpoint: report.msn,
    cardClass: cardClassFull
  },
  7: {
    id: REPORT_NAME.OBJECTS_PROCESSING, // 3,
    title: 'Реестр. Объекты обращения с отходами. Обработка',
    windowType: FULL_MODAL,
    col: 3,
    showApo: true,
    endpoint: report.objects,
    cardClass: cardClassFull
  },
  8: {
    id: REPORT_NAME.TECH, // 4,
    title: 'Реестр. Банк данных технологий',
    windowType: SMALL_MODAL,
    inApi: true,
    col: 4,
    endpoint: report.technology,
    cardClass: cardClassWithOutApo
  },
  9: {
    id: REPORT_NAME.GARBAGE_BANK, // 8,
    title: 'Реестр. Банк данных об отходах',
    windowType: SMALL_MODAL,
    col: 1,
    endpoint: report.bdo,
    cardClass: cardClassWithOutApo
  },
  10: {
    id: REPORT_NAME.MMCO, // 1,
    title: 'Перечень МО, направляющих отходы на ММЦОО, схема обращения с отходами на террритории',
    windowType: FULL_MODAL,
    col: 2,
    showApo: true,
    endpoint: report.mmzoo,
    cardClass: cardClassFull
  },
  11: {
    id: REPORT_NAME.OBJECTS_PLACING, // 31,
    title: 'Реестр. Объекты обращения с отходами. Размещение',
    windowType: FULL_MODAL,
    col: 3,
    showApo: true,
    endpoint: report.objects,
    cardClass: cardClassFull
  },
  12: {
    id: REPORT_NAME.MSN_INDICATOR, // 2,
    title: 'Удельные показатели по навалам мусора',
    windowType: FULL_MODAL,
    col: 4,
    showApo: true,
    endpoint: report.specificheap,
    cardClass: cardClassOnlyApo
  },
  13: {
    id: REPORT_NAME.RECYCLE, // 16,
    title: 'Сводный отчет по сбору вторсырья',
    windowType: SMALL_MODAL,
    col: 1,
    endpoint: report.secondary,
    cardClass: cardClassEmpty
  },
  14: {
    id: REPORT_NAME.GARBAGE_VOLUME_BY_MO, // 17
    title: 'Объем образования отходов по нормативам МО',
    windowType: FULL_MODAL,
    col: 2,
    showApo: true,
    endpoint: report.standart,
    cardClass: cardClassFull
  }
}

const configDataHmao = {
  ...configDataDefault,
  15: {
    id: REPORT_NAME.TP2Revegetation,
    title: 'Отчет по форме 2ТП(рекультивация)',
    to: {name: 'analytic.reports.reportRevegetation'},
    col: 3
  }
}

const configData = {
  default: configDataDefault,
  [HMAO]: configDataHmao
}

export default region.getRegionConfig(configData)
